module.exports = __webpack_public_path__ + "img/pic-1.f6d9fe6a.jpg";